import { TitleCasePipe } from '@angular/common';

export const displayUserType = (value: any, _args?: any): any => {
  if (value) {
    value = value.replace(new RegExp('_', 'g'), ' ');
    value = new TitleCasePipe().transform(value);
    return value.replace('Ce', 'CE');
  } else {
    return value;
  }
}
